module.exports = __webpack_public_path__ + "img/17 Animation 2-squashed.4778b9b5.jpg";